<template>
  <material-card>
    <v-avatar tile color="white" slot="offset" size="160" width="400" class="mx-auto d-block elevation-8">
      <v-img contain width="90%" :src="imgSrc" />
    </v-avatar>

    <v-card-text class="text-xs-center">
      <h4 class="font-weight-light mb-3">PARTNER KARTY</h4>

      <h2 class="mb-3 break-word">{{ data.name }}</h2>

      <h4 v-if="isHidden" class="mb-3 break-word">Ukryty</h4>

      <p v-if="data.descriptionShort" class="font-weight-light mt-1">{{ data.descriptionShort }}</p>

      <v-list two-line>
        <v-list-tile v-if="data.phoneNumber">
          <v-list-tile-action>
            <v-icon color="grey darken-1">mdi-phone</v-icon>
          </v-list-tile-action>

          <v-list-tile-content class="font-weight-light">
            <v-list-tile-title>{{ data.phoneNumber }}</v-list-tile-title>

            <v-list-tile-sub-title />
          </v-list-tile-content>
        </v-list-tile>

        <v-divider v-if="data.phoneNumber" />

        <v-list-tile v-if="data.email">
          <v-list-tile-action>
            <v-icon color="grey darken-1">mdi-email</v-icon>
          </v-list-tile-action>

          <v-list-tile-content class="font-weight-light">
            <v-list-tile-title>{{ data.email }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="data.website">
          <v-list-tile-action>
            <v-icon color="grey darken-1">mdi-web</v-icon>
          </v-list-tile-action>

          <v-list-tile-content class="font-weight-light">
            <v-list-tile-title>{{ data.website }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="data.city">
          <v-list-tile-action>
            <v-icon color="grey darken-1">mdi-map-marker</v-icon>
          </v-list-tile-action>

          <v-list-tile-content class="font-weight-light">
            <v-list-tile-title>{{ data | address }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card-text>

    <modal :show="editModal" :partnerToEdit="data" :edit="edit" @close="hideEditModal" @update="updatePartner" />

    <v-layout justify-center row wrap style="padding: 1em" slot="actions">
      <check-permission v-if="activateButton" permissions="PARTNER.CONFIRM" entityType="partner" :entityId="partnerId">
        <v-btn dark flat color="blue darken-2" @click="showConfirmDialog = true">
          <v-icon left>mdi-check-circle</v-icon>Potwierdź
        </v-btn>
      </check-permission>

      <check-permission v-if="removeButton" permissions="PARTNER.DELETE" entityType="partner" :entityId="partnerId">
        <v-btn dark flat color="blue darken-2" @click="showDeleteDialog = true">
          <v-icon left>mdi-trash-can-outline</v-icon>Usuń
        </v-btn>
      </check-permission>

      <check-permission permissions="PARTNER.UPDATE" entityType="partner" :entityId="partnerId">
        <v-btn dark flat color="blue darken-2" @click="showEditModal"> <v-icon left>edit</v-icon>Edytuj </v-btn>
      </check-permission>

      <check-permission permissions="PARTNER.EMPLOYEE_ADD" entityType="partner" :entityId="partnerId">
        <v-btn v-if="isOfficial" dark flat color="blue darken-2" @click="showEmployees">
          <v-icon left>mdi-account-details</v-icon>Pracownicy
        </v-btn>

        <router-link v-else :to="{ name: 'employees' }">
          <v-btn dark flat color="blue darken-2"> <v-icon left>mdi-account-details</v-icon>Pracownicy </v-btn>
        </router-link>
      </check-permission>

      <check-permission v-if="showToggleHidden" permissions="PARTNER.UPDATE" entityType="partner" :entityId="partnerId">
        <v-btn dark flat color="blue darken-2" @click="toggleHidden">
          {{ toggleHiddenButtonText }}
        </v-btn>
      </check-permission>
    </v-layout>

    <material-dialog
      title="Potwierdź usunięcie"
      text="Czy na pewno chcesz usunąć partnera?"
      :show="showDeleteDialog"
      @close="closeDialog"
      @confirm="remove"
    />

    <material-dialog
      cancelColor="error"
      confirmColor="green darken-1"
      title="Potwierdź aktywacje"
      text="Czy na pewno chcesz aktywować partnera?"
      :show="showConfirmDialog"
      @close="closeDialog"
      @confirm="activate"
    />
  </material-card>
</template>

<script>
import { partnerResource } from '@witkac/kartamiejska-resources';
import { address, isOfficial, SessionStorage, sharedConfig, StateString } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import { config } from '@/utils/config';
import Modal from './modals/Edit.modal';

// @vuese
// Wyświetlanie informacji o partnerze
// @group Partners
export default {
  components: {
    MaterialCard,
    MaterialDialog,
    Modal
  },
  data() {
    return {
      editModal: false,
      edit: true,
      showDeleteDialog: false,
      showConfirmDialog: false
    };
  },
  methods: {
    // @vuese
    // Funkcja wywołuje modal edycji partnera
    showEditModal() {
      this.editModal = true;
    },
    // @vuese
    // Funkcja ukrywa modal edycji partnera
    hideEditModal() {
      this.editModal = false;
    },
    // @vuese
    // Funkcja wywołuje metodę w store do aktualizacji partnera
    // @arg `data` dane usługi do aktualizacji
    updatePartner(data) {
      try {
        this.$store.dispatch('partners/update', data);
      } catch (error) {
        alert(error);
      }
    },
    // @vuese
    // Funkcja przechodzi do pracowników podmiotu
    showEmployees() {
      localStorage.setItem(SessionStorage.PARTNER_ID, '' + this.$route.params.id);
      this.$router.push({ name: 'employeesById', params: { id: parseInt(this.$route.params.id) } });
    },
    // @vuese
    // Zamyka dialog
    closeDialog() {
      this.showDeleteDialog = false;
      this.showConfirmDialog = false;
    },
    // @vuese
    // Usuwa partnera
    async remove() {
      try {
        await this.$store.dispatch('partners/remove', this.partnerId);
        this.$router.push({ name: 'partners' });
      } catch (error) {
        this.$store.dispatch('notifyError', { title: 'Nie udało się usunąć Partnera' });
      }
      this.showDeleteDialog = false;
    },
    // @vuese
    // Aktywuje partnera
    activate() {
      partnerResource
        .confirm(this.partnerId)
        .then(() => {
          this.$router.go();
        })
        .catch(err => this.$store.dispatch('notifyError', { title: 'Nie udało się aktywować Partnera' }));
      this.showConfirmDialog = false;
    },
    // @vuese
    // Pokazuje/ukrywa partnera
    toggleHidden() {
      this.$store
        .dispatch('partners/toggleHidden', this.partnerId)
        .then(() =>
          this.$store.dispatch('notifySuccess', {
            title:
              this.data.state === StateString.HIDDEN
                ? 'Udało się ukryć Partnera.'
                : 'Partner będzie widoczny publicznie.'
          })
        )
        .catch(err =>
          this.$store.dispatch('notifyError', {
            title:
              this.data.state === StateString.HIDDEN
                ? 'Nie udało się ukryć Partnera.'
                : 'Wystąpił błąd. Partner pozostanie ukryty.'
          })
        );
    }
  },
  computed: {
    ...mapState({
      data: state => state.partners.data,
      partnerId: state => state.partners.id
    }),
    imgSrc() {
      if (this.data.mainImage) {
        return `${config.mediaURL}/${this.data.mainImage}?${sharedConfig.sizes.avatar.medium.queryString}`;
      }
      return '/img/logo' + Math.floor(Math.random() * 4 + 1) + '.png';
    },
    activateButton() {
      return isOfficial() && StateString.NOT_CONFIRMED === this.data.state;
    },
    removeButton() {
      return isOfficial() && StateString.ACTIVE === this.data.state;
    },
    isHidden() {
      return this.data.state === StateString.HIDDEN;
    },
    showToggleHidden() {
      return this.isHidden || this.data.state === StateString.ACTIVE;
    },
    toggleHiddenButtonText() {
      return this.data.state === StateString.HIDDEN ? 'Pokaż Partnera' : 'Ukryj Partnera';
    },
    isOfficial
  },
  watch: {
    '$store.state.modalClose.confirm'(val) {
      if (val) {
        this.hideEditModal();
        this.$store.dispatch('resetConfirmState');
      }
    }
  },
  filters: {
    address
  }
};
</script>

<style>
.break-word {
  word-break: break-word;
}
</style>
